import {
    MdDashboard,
    MdAdminPanelSettings,
    MdPeople,
    MdHistory,
    MdDescription,
    MdSupervisedUserCircle,
    MdRule,
    MdLink,
    MdPlace
} from 'react-icons/md';
import { HiDocumentDownload } from 'react-icons/hi';
import { FaFileContract, FaHospital } from 'react-icons/fa';

export const croAdminMenuItems = {
    dashboard: [
        { icon: MdDashboard, label: 'Dashboard', path: '/', badge: null }
    ],
    management: [
        {
            icon: FaFileContract,
            label: 'Consent Manager',
            path: '/consent-manager',
            badge: null,
            description: 'View all submitted consent with approve or decline'
        },
        {
            icon: MdDescription,
            label: 'Data Capture',
            path: '/data-capture',
            badge: null,
            description: 'Subject Enrollment with Data Capture View (All Sites)'
        },
        {
            icon: MdPeople,
            label: 'Members & Access',
            path: '/members-access',
            badge: null
        },
        {
            icon: MdAdminPanelSettings,
            label: 'Role Management',
            path: '/role-management',
            badge: null
        },
        {
            icon: MdSupervisedUserCircle,
            label: 'User Management',
            path: '/user-management',
            badge: null
        }
    ],
    settings: [
        { icon: MdRule, label: 'Consent Agreements and Rules', path: '/settings/consent-agreements' },
        { icon: FaHospital, label: 'Site Masters', path: '/settings/site-masters' },
        { icon: MdLink, label: 'Study – Site Association', path: '/settings/study-site-association' },
        { icon: MdPlace, label: 'Location Master', path: '/settings/location-master' },
        { icon: MdHistory, label: 'Audit Log', path: '/audit-trail' }
    ],
    reports: [
        {
            icon: HiDocumentDownload,
            label: 'Reports Studio',
            path: '/study-report',
            badge: 'NEW'
        }
    ]
};

export const sponsorMenuItems = {
    dashboard: [
        { icon: MdDashboard, label: 'Dashboard', path: '/', badge: null }
    ],
    management: [
        {
            icon: FaFileContract,
            label: 'Consent Manager',
            path: '/consent-manager',
            badge: null,
            description: 'View all submitted consent with approve or decline'
        },
        {
            icon: MdDescription,
            label: 'Data Capture',
            path: '/data-capture',
            badge: null,
            description: 'Subject Enrollment with Data Capture View (All Sites)'
        }
    ],
    reports: [
        {
            icon: HiDocumentDownload,
            label: 'Reports Studio',
            path: '/study-report',
            badge: null
        }
    ]
};

export const piMenuItems = {
    dashboard: [
        { icon: MdDashboard, label: 'Dashboard', path: '/', badge: null }
    ],
    management: [
        {
            icon: FaFileContract,
            label: 'My Consent',
            path: '/consent-manager',
            badge: null,
            description: ''
        },
        {
            icon: MdDescription,
            label: 'Data Capture',
            path: '/data-capture',
            badge: null,
            description: ''
        }
    ]
};

export const dataManagerMenuItems = {
    dashboard: [
        { icon: MdDashboard, label: 'Dashboard', path: '/', badge: null }
    ]
};